import { SET_AUTO_PAY_ENABLED } from './actionTypes';

const initialState = {
  isAutoPayEnabled: false,
};

const progressivePlansRedesignReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTO_PAY_ENABLED:
      return {
        ...state,
        isAutoPayEnabled: action.payload,
      };
    default:
      return state;
  }
};

export default progressivePlansRedesignReducer;